import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAdminAuth } from "../../contexts/AdminAuthContext";

/**
 * Gate for /admin/* routes. Three states:
 *  - admin === null: still checking → loading shell
 *  - admin === false: not logged in → redirect to /admin/login
 *  - admin object: logged in → render children/outlet
 *
 * If admin.must_change_password === true and we're not already on the
 * change-password screen, redirect there.
 */
export default function RequireAdmin({ children }) {
  const { admin } = useAdminAuth();
  const location = useLocation();

  if (admin === null) {
    return (
      <div data-testid="admin-loading" className="min-h-screen bg-cream flex items-center justify-center">
        <div className="flex items-center gap-3 text-ink/60">
          <span className="h-2.5 w-2.5 rounded-full bg-brand-pink animate-ping" />
          <span className="font-display text-sm">Yükleniyor…</span>
        </div>
      </div>
    );
  }

  if (admin === false) {
    return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />;
  }

  if (admin.must_change_password && location.pathname !== "/admin/change-password") {
    return <Navigate to="/admin/change-password" replace />;
  }

  return children ?? <Outlet />;
}
